var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 9,
    fill: "none",
    viewBox: "0 0 14 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C6C6C",
    d: "m7.155 8.257.6-.56 5.655-5.33-1.202-1.46-5.053 4.761L2.102.907.9 2.367l5.653 5.33.601.56z"
  })));
};
export default SvgArrow;